import React, { useEffect, useState } from 'react';

import MasterCardLogo from '../../assets/master-logo.png';
import PayPalLogo from '../../assets/pp-logo.png';
import VisaLogo from '../../assets/visa-logo.png';


export const PaymentMethods = (props) => {
  const {
    epochAvailable,
    selectedPaymentMethod,
    paysafeAvailable,
    oneClickPaymentData,
    onPaymentMethodChange,
  } = props;
  const [shouldRenderPaymentMethods, setShouldRenderPaymentMethods] = useState(false);

  useEffect(() => {
    if (!oneClickPaymentData && (epochAvailable || paysafeAvailable?.length > 1)) {
      setShouldRenderPaymentMethods(true);
    }
  }, [oneClickPaymentData, epochAvailable, paysafeAvailable]);

  if (!shouldRenderPaymentMethods) {
    return null;
  }

  return (
    <>
      <div className="payment-options-header">
        <h3 className="caps">CHOOSE YOUR PAYMENT METHOD</h3>
      </div>
      {epochAvailable && (
        <label className="package">
          <input
            checked={selectedPaymentMethod === 'EW' || !paysafeAvailable}
            className="package-radio inverse"
            type="radio"
            value="EW"
            onChange={onPaymentMethodChange}
          />
          <span />
          <p className="montserrat package-timespan payment-method">PayPal</p>
          <div className="payment-logo-paypal pull-right">
            <img alt="" src={PayPalLogo} />
          </div>
        </label>
      )}
      {paysafeAvailable && (
        <label className="package">
          <input
            checked={selectedPaymentMethod === 'CC' || !epochAvailable}
            className="package-radio inverse"
            type="radio"
            value="CC"
            onChange={onPaymentMethodChange}
          />
          <span />
          <p className="montserrat package-timespan payment-method">
            <span>Credit Card</span>
          </p>
          <p className="payment-logo-visa pull-right">
            <img alt="" src={VisaLogo} style={{ marginRight: '10px' }} />
            <img alt="" src={MasterCardLogo} />
          </p>
        </label>
      )}
    </>
  );
};


